
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form3DataInfoType } from '@/types/Information/Form3';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form3Layout extends Vue {

    @Prop({required:true})
    result!: form3DataInfoType;
}

